import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productImageAlt, productTag, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} complete volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-background" data-id="element-84" data-mp="sa9nj0m1r5qb">
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-85" data-mp="ncq0pcba9kmr">
        <span className="flex-1 bg-primary" data-id="element-86" data-mp="neaugzprwzjk" />
        <span className="glow-line w-24 bg-highlight" data-id="element-87" data-mp="3d1sdb54ebxwt" />
        <span className="flex-1 bg-primary" data-id="element-88" data-mp="3czfoc8080na9" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-89" data-mp="381e0zavri1sz">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-highlight/50 bg-surface px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-foreground" data-id="element-90" data-mp="3j893p1w0vrk9">
          <ZapIcon className="glow-led h-4 w-4 text-highlight" aria-hidden="true" data-id="element-91" data-mp="30iazwxz9ckmf" /> {productTag}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-8 max-w-3xl" data-id="element-92" data-mp="3599k48nda2uy">
          <img src={productImage} alt={productImageAlt} className="mockup-glow mx-auto w-full" data-id="element-93" data-mp="2hj5e5umphr0s" />
        </motion.div>

        <div className="mt-9" data-id="element-94" data-mp="2lla5untlgdks">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-95" data-mp="2ljgz78izdtcs">
            Get Chemistry — Teacher Ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-foreground" data-id="element-96" data-mp="nbl2wm6daiaz">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-primary/60 bg-surface px-3 py-2" data-id="element-97" data-mp="ia5kl1vkqpwa">
              <Icon className="glow-led h-3.5 w-3.5 text-highlight" aria-hidden="true" data-id="element-98" data-mp="1b1fg54ulm8vr" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}